
import * as React from 'react'
import { Image, Text, View, TouchableOpacity, ScrollView } from 'react-native'
import images from '../../assets/images'
import { useTheme } from '@react-navigation/native'
import AnimatedProgressWheel from 'react-native-progress-wheel';
import Axios from 'axios'
import { RefreshControl } from 'react-native-web-refresh-control'

export default React.memo(function FinanceCumulative({ month_string }) {
    const { colors } = useTheme()
    const [data, setData] = React.useState()
    const [refreshing, setRefreshing] = React.useState(true)

    React.useEffect(() => {
        setRefreshing(true)
        Axios.get(`api/ceo/personnel_overview?month=${month_string}`)
            .then(res => {
                console.log(res)
                if (res.status === 200)
                    setData(res.data)
                setRefreshing(false)
            }).catch(err => {
                setRefreshing(false)
                console.log(err)
            })
    }, [month_string])

    const onRefresh = () => {
        setRefreshing(true)
        Axios.get(`api/ceo/personnel_overview?month=${month_string}`)
            .then(res => {
                console.log(res)
                if (res.status === 200) {
                    setData(res.data)
                }
                setRefreshing(false)
            }).catch(err => {
                setRefreshing(false)
                console.log(err)
            })
    }


    const getColorProgress = (value) => {
        console.log(value)
        if (value <= 50) {
            return colors.process_3
        } else if (value > 50 && value < 75) {
            return colors.process_1
        }
        return colors.process_2
    }

    const getColorText = (value) => {
        try {
            if (value < 50) return colors.text_red
            else if (value < 75) return colors.text_yellow
            else return colors.text_green
        } catch (error) {
        }
    }

    return (
        <ScrollView style={{ flex: 1 }} refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} tintColor={colors.text} colors={[colors.text]} />}>
            {
                data ? <>
                    <View style={{ backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15 }}>
                        <View style={{ marginTop: 8, flexDirection: 'column', alignItems: 'center', paddingBottom: 10 }}>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 15, color: colors.text }}>TỔNG SỐ NHÂN SỰ</Text>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 36, color: colors.text }}>{data?.personnel_reality?.personnel_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 12, color: colors.text }}>{data?.personnel_reality?.personnel_increase > 0 && `+`}{data?.personnel_reality?.personnel_increase.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} </Text>
                                <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 12, color: colors.text_sub }}>so với đầu kỳ: </Text>
                                <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 12, color: colors.text }}>{data?.personnel_reality?.personnel_beginning.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            </View>
                        </View>
                    </View>

                    <View style={{ flexDirection: 'row', paddingHorizontal: 12, marginTop: 18 }}>
                        <View style={{ flex: 1, backgroundColor: 'white', borderRadius: 10, paddingHorizontal: 12, paddingTop: 8, paddingBottom: 8, flexDirection: 'column' }}>
                            <View style={{ flexDirection: 'row' }}>
                                <View style={{ flex: 1 }}>
                                    <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text_red, fontSize: 11 }}>Số nhân sự nghỉ việc</Text>
                                    {/* <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 24, color: colors.text, lineHeight: 28 }}>{data?.personnel_quit_job?.personnel_quit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text> */}
                                </View>
                            </View>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', paddingTop: 4, alignItems: 'flex-end' }}>
                                <View style={{ width: 34 }}>
                                    <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 24, color: colors.text_red, alignItems: 'flex-end', }}>{data?.personnel_quit_job?.personnel_quit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                </View>
                                <View style={{ flex: 1, paddingBottom: 4 }}>
                                    <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 11, color: colors.text_sub }}><Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 11, color: colors.text_sub }}>= </Text><Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 11, color: colors.text }}>{data?.personnel_quit_job?.personnel_percent_beginning}%</Text> so với đầu kỳ</Text>
                                </View>
                            </View>

                        </View>
                        <View style={{ width: 16 }}></View>

                        <View style={{ flex: 1, backgroundColor: 'white', borderRadius: 10, paddingHorizontal: 12, paddingTop: 8, paddingBottom: 8, flexDirection: 'column' }}>
                            <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
                                <View style={{ flex: 1 }}>
                                    <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text_green, fontSize: 11 }}>Số nhân sự tuyển mới</Text>
                                    {/* <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 24, color: colors.text, lineHeight: 28 }}>{data?.number_customer?.passenger_day.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text> */}
                                </View>
                            </View>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', paddingTop: 4, alignItems: 'flex-end' }}>
                                <View style={{ width: 34 }}>
                                    <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 24, color: colors.text_green, alignItems: 'flex-end', }}>{data?.personnel_new_recruitment?.personnel_new.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                </View>
                                <View style={{ flex: 1, paddingBottom: 4 }}>
                                    <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 11, color: colors.text_sub }}><Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 11, color: colors.text_sub }}>= </Text><Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 11, color: colors.text }}>{data?.personnel_new_recruitment?.personnel_percent_beginning}%</Text> so với đầu kỳ</Text>
                                </View>
                            </View>
                        </View>
                    </View>

                    <View style={{ backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15 }}>
                        <View style={{ marginTop: 8, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignContent: 'center' }}>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 15, color: colors.text }}>Hệ số lao động/phương tiện</Text>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 24, color: colors.text }}>{data?.labor_coefficient?.coefficient}</Text>
                        </View>

                        <View style={{ flexDirection: 'row', marginBottom: 16, alignItems: 'center', alignContent: 'center', marginTop: 8 }}>
                            <Text style={{ paddingRight: 12, fontFamily: 'Nunito_700Bold', fontSize: 12, color: colors.text_sub }}><Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 12, color: colors.text }}>{data?.labor_coefficient?.coefficient_last}%</Text> tháng trước</Text>
                            <View style={{
                                height: 10, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                justifyContent: 'center'
                            }}>
                                <View style={{
                                    position: 'absolute', top: 0, left: 0, width: `${data?.labor_coefficient?.coefficient_last}%`,
                                    height: '100%', backgroundColor: getColorProgress(data?.labor_coefficient?.coefficient_last), borderRadius: 3
                                }} />
                            </View>
                        </View>
                    </View>

                    <View style={{ backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15, paddingBottom: 12 }}>
                        <View style={{ marginTop: 8, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', }}>
                            <View style={{ flexDirection: 'row', marginBottom: 8, marginTop: 4 }}>
                                <Image source={images.icons.icon_presentation} style={{ height: 20, width: 20, resizeMode: 'contain', marginRight: 11 }} />
                                <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 15, color: colors.text }}>Đào tạo</Text>
                            </View>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 14, color: colors.text }}>8 <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 12, color: colors.text_sub }}>giờ/người</Text></Text>
                        </View>

                        <View style={{ flexDirection: 'row', alignItems: 'center', alignContent: 'center' }}>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 15, color: colors.text_sub }}>Số nhân viên được đào tạo:</Text>
                            <Text style={{ paddingHorizontal: 8, fontFamily: 'Nunito_700Bold', fontSize: 24, color: colors.text }}>{data?.educate?.educate_personnel}</Text>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 15, color: colors.text_sub }}>người</Text>
                        </View>
                        <View style={{ flexDirection: 'row', alignItems: 'center', alignContent: 'center' }}>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 15, color: colors.text_sub }}>Tổng số giờ đào tạo:</Text>
                            <Text style={{ paddingHorizontal: 8, fontFamily: 'Nunito_700Bold', fontSize: 24, color: colors.text }}>{data?.educate?.educate_time}</Text>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 15, color: colors.text_sub }}>giờ</Text>
                        </View>
                    </View>


                    <View style={{
                        backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15,
                        paddingVertical: 8, flexDirection: 'row'
                    }}>
                        <View style={{ flexDirection: 'column', flex: 1 }}>
                            <View style={{ flexDirection: 'row', marginBottom: 8, marginTop: 4 }}>
                                <Image source={images.icons.icon_driver} style={{ height: 20, width: 20, resizeMode: 'contain', marginRight: 11 }} />
                                <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 15 }}>Lái xe (đầu kỳ)</Text>
                            </View>
                            <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 20 }}>{data?.driver?.driver_number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 14, color: colors.text_sub }}>định biên:  <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 14, color: colors.text }}>{data?.driver?.driver_compile.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text></Text>
                        </View>
                        <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <View style={{ position: 'relative' }}>
                                <AnimatedProgressWheel
                                    size={70}
                                    width={10}
                                    color={getColorProgress(data?.driver?.driver_ratio)}
                                    backgroundColor={colors.process_background}
                                    progress={parseFloat(data?.driver?.driver_ratio)}
                                    animateFromValue={0}
                                    duration={3000}
                                />
                                <View style={{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: 0 }}>
                                    <Text style={{
                                        fontFamily: 'Nunito_700Bold', color: getColorText(data?.driver?.driver_ratio),
                                        fontSize: 10, textAlign: 'center', marginTop: 5
                                    }}>{Math.round(data?.driver?.driver_ratio * 100) / 100}%{'\n'}đb</Text>
                                </View>
                            </View>
                        </View>
                    </View>

                    <View style={{
                        backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15,
                        paddingVertical: 8, flexDirection: 'row'
                    }}>
                        <View style={{ flexDirection: 'column', flex: 1 }}>
                            <View style={{ flexDirection: 'row', marginBottom: 8, marginTop: 4 }}>
                                <Image source={images.icons.icon_hostess} style={{ height: 20, width: 20, resizeMode: 'contain', marginRight: 11 }} />
                                <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 15 }}>Tiếp viên (đầu kỳ)</Text>
                            </View>
                            <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 20 }}>{data?.stewardess?.stewardess.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 14, color: colors.text_sub }}>định biên:  <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 14, color: colors.text }}>{data?.stewardess?.stewardess_quota.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text></Text>
                        </View>
                        <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <View style={{ position: 'relative' }}>
                                <AnimatedProgressWheel
                                    size={70}
                                    width={10}
                                    color={getColorProgress(data?.stewardess?.stewardess_ratio)}
                                    backgroundColor={colors.process_background}
                                    progress={parseFloat(data?.stewardess?.stewardess_ratio)}
                                    animateFromValue={0}
                                    duration={3000}
                                />
                                <View style={{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: 0 }}>
                                    <Text style={{
                                        fontFamily: 'Nunito_700Bold', color: getColorText(data?.stewardess?.stewardess_ratio),
                                        fontSize: 10, textAlign: 'center', marginTop: 5
                                    }}>{Math.round(data?.stewardess?.stewardess_ratio * 100) / 100}%{'\n'}đb</Text>
                                </View>
                            </View>
                        </View>
                    </View>

                    <View style={{
                        backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15,
                        paddingVertical: 8, flexDirection: 'row'
                    }}>
                        <View style={{ flexDirection: 'column', flex: 1 }}>

                            <View style={{ flexDirection: 'row', marginBottom: 8, marginTop: 4, alignItems: 'center' }}>
                                <Image source={images.icons.icon_team} style={{ height: 20, width: 20, resizeMode: 'contain', marginRight: 11 }} />
                                <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 15 }}>Nhân sự còn lại (đầu kỳ)</Text>
                            </View>

                            <Text style={{ fontFamily: 'Nunito_700Bold', color: colors.text, fontSize: 20 }}>{data?.not_driver?.not_driver_number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 14, color: colors.text_sub }}>định biên:  <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 14, color: colors.text }}>{data?.not_driver?.not_driver_compile.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text></Text>
                        </View>
                        <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <View style={{ position: 'relative' }}>
                                <AnimatedProgressWheel
                                    size={70}
                                    width={10}
                                    color={getColorProgress(data?.not_driver?.not_driver_ratio)}
                                    backgroundColor={colors.process_background}
                                    progress={parseFloat(data?.not_driver?.not_driver_ratio)}
                                    animateFromValue={0}
                                    duration={3000}
                                />
                                <View style={{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: 0 }}>
                                    <Text style={{
                                        fontFamily: 'Nunito_700Bold', color: getColorText(data?.not_driver?.not_driver_ratio),
                                        fontSize: 10, textAlign: 'center', marginTop: 5
                                    }}>{Math.round(data?.not_driver?.not_driver_ratio * 100) / 100}%{'\n'}đb</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={{ marginBottom: 16 }} />
                </> : (
                        !refreshing ? <View style={{ marginTop: 80, flexDirection: 'column', alignItems: 'center' }}>
                            <Image source={images.server_error} style={{ width: 200, height: 200 }} />
                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', marginTop: 24, fontSize: 18 }}>Đã có lỗi xảy ra</Text>
                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>Vui lòng ấn nút bên dưới để thử lại</Text>
                            <TouchableOpacity onPress={onRefresh}>
                                <Image source={images.refresh} style={{ width: 40, height: 40, marginTop: 16 }} />
                            </TouchableOpacity>
                        </View> : null
                    )
            }
        </ScrollView>
    );
})